import ProductType from '../enums/ProductType';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logUpsellProductClickedParams = {
  product_type?: ProductType;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * On upsells where multiple products are offered, the users clicks on to select one of the products.
 * @param params - Attributes to log with the amplitude event
 * @param params.product_type - The product type selected from the upsell menu (e.g. free, plus, peak)
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.trigger - Action that triggered the upsell to display
 */
const logUpsellProductClicked = ({ product_type, purchase_screen_type_plan, trigger }: logUpsellProductClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'upsell product clicked',
    { 'product type': product_type, 'purchase screen type plan': purchase_screen_type_plan, trigger },
    callback
  );
};

export default logUpsellProductClicked;
